import { memo, useCallback, useMemo } from 'react';
import { Row } from 'shards-react';
import PasswordStrengthBar from 'react-password-strength-bar';
import StatefulField from './StatefulField';

const NewPasswordField = ({ newPassword, setNewPassword, passwordScore, setPasswordScore, isNewPassUnique }) => {
  const lowerLetter = useMemo(() => newPassword !== newPassword.toUpperCase(), [newPassword]);
  const upperLetter = useMemo(() => newPassword !== newPassword.toLowerCase(), [newPassword]);
  const containsDigit = useMemo(() => /\d/.test(newPassword), [newPassword]);
  const specialChars = useMemo(() => /[\W_]/.test(newPassword), [newPassword]);
  const isValid = useMemo(() => lowerLetter && upperLetter && containsDigit && specialChars && isNewPassUnique && passwordScore > 1, [isNewPassUnique, passwordScore, lowerLetter, upperLetter, containsDigit, specialChars]);
  const hint = useMemo(() => {
    if (!isNewPassUnique) return 'Das neue Passwort sollte sich vom Alten unterscheiden!';
    if (!isValid) return 'Das neue Passwort sollte mindestens 8 Zeichen enthalten, einschließlich Großbuchstaben, Kleinbuchstaben, Zahlen und Sonderzeichen.';
    return '';
  }, [isNewPassUnique, isValid]);

  const handleScoreChange = useCallback((score) => setPasswordScore(score), [setPasswordScore]);

  return (
    <>
      <StatefulField
        id='new-password'
        type='password'
        isRequired={true}
        autoComplete='new-password'
        label='Neues Passwort'
        placeholder='Bitte geben Sie Ihr neues Passwort ein.'
        value={newPassword}
        updateValue={setNewPassword}
        validator={isValid}
        hint={hint}
      />
      <Row>
        <PasswordStrengthBar className='col-md-6' password={newPassword} minLength={8} scoreWords={['schwach', 'schwach', 'ok', 'gut', 'stark']} shortScoreWord='zu kurz' onChangeScore={handleScoreChange} />
      </Row>
    </>
  );
};

export default memo(NewPasswordField);
